import * as React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PhenBot from '../images/phenbot.png';

export const CustomWidthTooltip = styled(({ className, ...props }) => (
      
      <Tooltip {...props} classes={{ popper: className }} 
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '1.2rem', 
            },
          },
        }} 
      >
        { props.showPhen === 'true' &&
            <Button sx={{ cursor: 'pointer' }}>            
                <img src={PhenBot} style={{ '&:hover': { cursor: 'pointer' }, ml: 2, minHeight: '5px', maxHeight: '75px', minWidth: '15px', maxWidth: '75px', paddingLeft: '10px', justifyContent: '', verticalAlign: 'top' }} alt={HelpOutlineIcon}/>
            </Button>
        }
      </Tooltip>
  ))
  (({ dynamicWidth, dynamicHeight }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: dynamicWidth, 
      height: dynamicHeight,
      whiteSpace: 'normal',
      backgroundColor: '#1f1d1d',
    },
}))
